export enum HUBSPOT_ENDPOINTS {
  FORMS = "https://api.hsforms.com/submissions/v3/integration/submit/"
}

export enum BASE_ENDPOINTS {
  CRISPY = "https://crispy.perpetua.io",
  BIZZABO = "https://api.bizzabo.com/api"
}

export enum ACCOUNT_ENDPOINTS {
  USER_DATA = "/account/v2/auth/user_v2/",
  SIGN_UP = "/account/v2/auth/signup_v2/",
  MAGIC_LINK = "/account/v2/auth/magiclink/email/",
  EMAIL_INVITE = "/account/v2/auth/email/invites/",
  MAGIC_LOGIN = "/account/v2/magic_link/login/"
}
